export default __webpack_public_path__ + "static/media/eventLocation.5f979c50.svg";